/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Permission_Name_Userskillgroups_WriteInputs */

const en_enum_permission_name_userskillgroups_write = /** @type {(inputs: Enum_Permission_Name_Userskillgroups_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Userskillgroups Write`)
};

const de_enum_permission_name_userskillgroups_write = /** @type {(inputs: Enum_Permission_Name_Userskillgroups_WriteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name Userskillgroups Write`)
};

/**
* | output |
* | --- |
* | "Name Userskillgroups Write" |
*
* @param {Enum_Permission_Name_Userskillgroups_WriteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_permission_name_userskillgroups_write = /** @type {((inputs?: Enum_Permission_Name_Userskillgroups_WriteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Permission_Name_Userskillgroups_WriteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_permission_name_userskillgroups_write(inputs)
	return de_enum_permission_name_userskillgroups_write(inputs)
});